export default __webpack_public_path__ + "images/a4cf4e54ce82d6ac0fd5fb27c976d307.png";